module.exports = __webpack_public_path__ + "img/paterna.751a188b.webp";